import moment from 'moment';
import { IClubTransaction } from '../../../../store/admin/clubs/store';

interface IFormattedTransactionData {
  eventName: string;
  formattedAmount: string;
  formattedDate: string;
  payeer: string;
  paymentMethod: string;
  type: string;
}

type IGetFormattedTransactionData = (transaction: IClubTransaction) => IFormattedTransactionData;

export const getFormattedTransactionData: IGetFormattedTransactionData = transaction => {
  const {
    amount,
    created,
    payeer: { firstName, lastName },
    processorId,
    summary: {
      coupon,
      items: { eventPrice, eventName, clubMembershipPrice }
    }
  } = transaction;

  const formattedDate = moment(created).format('D/MM/YYYY');
  const payeer = `${firstName} ${lastName}`;
  const formattedAmount = `$${amount}`;
  const paymentMethod = processorId ? 'CC' : Object.keys(coupon).length > 0 ? 'COUPON' : 'MANUAL';
  const type = eventPrice ? 'Event Entry' : clubMembershipPrice ? 'Club membership' : '-';

  return {
    eventName: eventName || type,
    formattedAmount,
    formattedDate,
    payeer,
    paymentMethod,
    type
  };
};
